<ng-container *ngIf="items.length > 0">
  <label>Campi dinamici</label>
  <span class="p-input-icon-left w-full mb-2 block">
    <i class="pi pi-search"></i>
    <input
      pInputText
      type="text"
      class="w-full"
      placeholder="Cerca campo..."
      [(ngModel)]="filterText" />
  </span>
  <div class="scrollable">
    <p-menu
      [model]="filteredItems"
      styleClass="w-full border-none"></p-menu>
    <p
      *ngIf="filteredItems.length === 0"
      class="text-color-secondary text-sm mt-2 mb-0">
      Nessun campo trovato.
    </p>
  </div>
</ng-container>
